function employeeId(line) { return Number(line.employee_id || line.resolved_employee_id || line.unresolved_person && line.unresolved_person.resolved_employee_id); }
const layoutFrame = () => typeof requestAnimationFrame === 'function' ? new Promise(resolve => requestAnimationFrame(resolve)) : Promise.resolve();

export default {
    computed: {
        requestedEmployeeId() {
            const raw = this.$route.query.focus_employee_id;
            if (typeof raw !== 'string' || !/^[1-9]\d*$/.test(raw)) return null;
            const id = Number(raw);
            return Number.isSafeInteger(id) ? id : null;
        },
        employeeFocusKey() {
            if (!this.requestedEmployeeId || !this.sheet || this.reviewMode
                || Number(this.$route.params.timesheetId) !== Number(this.sheet.timesheet.id)) return '';
            return `${this.sheet.timesheet.id}:${this.requestedEmployeeId}`;
        },
        employeeFocusedLineIds() {
            return this.employeeFocusKey ? this.sheet.lines.filter(line => employeeId(line) === this.requestedEmployeeId).map(line => Number(line.id)) : [];
        },
        employeeFocusMessage() {
            return this.employeeFocusKey && !this.employeeFocusedLineIds.length ? 'Сотрудник больше не входит в этот табель' : '';
        }
    },
    watch: {
        employeeFocusKey() { this._employeeFocusApplied = ''; return this.focusRequestedEmployee(); }
    },
    methods: {
        isEmployeeFocused(line) { return this.employeeFocusedLineIds.includes(Number(line.id)); },
        async focusRequestedEmployee() {
            const key = this.employeeFocusKey;
            if (!key || this.loading || this.periodTransition || this._employeeFocusApplied === key || this._employeeFocusPending === key) return;
            const lineId = this.employeeFocusedLineIds[0];
            if (!lineId) return;
            this._employeeFocusPending = key;
            try {
                if (!this.isHistoricalSheet) {
                    this.mobileMode = 'month'; this.mobileMonthLayout = 'full';
                    this.revealEmployeeSearchLine(lineId);
                }
                await this.$nextTick();
                // ResizeObserver and the viewport layout settle after Vue's DOM patch.
                await layoutFrame();
                if (this._isDestroyed || this.employeeFocusKey !== key) return;
                // Bring the viewport on screen before its height and virtual window are measured.
                const viewport = this.$refs.monthScroll;
                if (viewport) {
                    viewport.scrollIntoView({behavior: 'auto', block: 'center', inline: 'nearest'});
                    await layoutFrame();
                    await this.$nextTick();
                    await layoutFrame();
                    if (this._isDestroyed || this.employeeFocusKey !== key) return;
                }
                if (this.$refs.monthRows) await this.$refs.monthRows.reveal(lineId);
                await this.$nextTick();
                await layoutFrame();
                if (this._isDestroyed || this.employeeFocusKey !== key) return;
                const row = Array.from(this.$el.querySelectorAll(`[data-review-line-id="${lineId}"]`)).find(element => element.getClientRects().length);
                if (row) {
                    row.scrollIntoView({behavior: 'auto', block: 'center', inline: 'nearest'});
                    this._employeeFocusApplied = key;
                }
            } finally {
                if (this._employeeFocusPending === key) this._employeeFocusPending = '';
            }
        }
    }
};
